var map = {
	"../comunicaciones/comunicaciones.module": [
		"./src/app/pages/comunicaciones/comunicaciones.module.ts",
		"comunicaciones-comunicaciones-module"
	],
	"../dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"../facturacion/facturacion.module": [
		"./src/app/pages/facturacion/facturacion.module.ts",
		"common",
		"facturacion-facturacion-module"
	],
	"../franjas/franjas.module": [
		"./src/app/pages/franjas/franjas.module.ts",
		"franjas-franjas-module"
	],
	"../operaciones/operaciones.module": [
		"./src/app/pages/operaciones/operaciones.module.ts",
		"operaciones-operaciones-module"
	],
	"../puntos-qr/puntos-qr.module": [
		"./src/app/pages/puntos-qr/puntos-qr.module.ts",
		"default~pages-seed-point-seed-point-module~pages-seed-update-seed-update-module~puntos-qr-puntos-qr-module",
		"default~pages-inventario-inventario-module~puntos-qr-puntos-qr-module",
		"puntos-qr-puntos-qr-module"
	],
	"../puntos/puntos.module": [
		"./src/app/pages/puntos/puntos.module.ts",
		"common",
		"puntos-puntos-module"
	],
	"../ruteros/ruteros.module": [
		"./src/app/pages/ruteros/ruteros.module.ts",
		"ruteros-ruteros-module"
	],
	"../seeds/seeds.module": [
		"./src/app/pages/seeds/seeds.module.ts",
		"common",
		"seeds-seeds-module"
	],
	"../usuarios/usuarios.module": [
		"./src/app/pages/usuarios/usuarios.module.ts",
		"usuarios-usuarios-module"
	],
	"./pages/auth/login/login.module": [
		"./src/app/pages/auth/login/login.module.ts",
		"pages-auth-login-login-module"
	],
	"./pages/auth/register/register.module": [
		"./src/app/pages/auth/register/register.module.ts",
		"common",
		"pages-auth-register-register-module"
	],
	"./pages/auth/terms/terms.module": [
		"./src/app/pages/auth/terms/terms.module.ts",
		"pages-auth-terms-terms-module"
	],
	"./pages/comunicaciones/comunicaciones.module": [
		"./src/app/pages/comunicaciones/comunicaciones.module.ts",
		"comunicaciones-comunicaciones-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./pages/detail-pedido/detail-pedido.module": [
		"./src/app/pages/detail-pedido/detail-pedido.module.ts",
		"pages-detail-pedido-detail-pedido-module"
	],
	"./pages/facturacion/facturacion.module": [
		"./src/app/pages/facturacion/facturacion.module.ts",
		"common",
		"facturacion-facturacion-module"
	],
	"./pages/forgot-password/forgot-password.module": [
		"./src/app/pages/forgot-password/forgot-password.module.ts",
		"pages-forgot-password-forgot-password-module"
	],
	"./pages/franjas/franjas.module": [
		"./src/app/pages/franjas/franjas.module.ts",
		"franjas-franjas-module"
	],
	"./pages/inventario/inventario.module": [
		"./src/app/pages/inventario/inventario.module.ts",
		"default~pages-inventario-inventario-module~puntos-qr-puntos-qr-module",
		"pages-inventario-inventario-module"
	],
	"./pages/operaciones/operaciones.module": [
		"./src/app/pages/operaciones/operaciones.module.ts",
		"operaciones-operaciones-module"
	],
	"./pages/puntos-qr/puntos-qr.module": [
		"./src/app/pages/puntos-qr/puntos-qr.module.ts",
		"default~pages-seed-point-seed-point-module~pages-seed-update-seed-update-module~puntos-qr-puntos-qr-module",
		"default~pages-inventario-inventario-module~puntos-qr-puntos-qr-module",
		"puntos-qr-puntos-qr-module"
	],
	"./pages/puntos/puntos.module": [
		"./src/app/pages/puntos/puntos.module.ts",
		"common",
		"puntos-puntos-module"
	],
	"./pages/recaudos/recaudos.module": [
		"./src/app/pages/recaudos/recaudos.module.ts",
		"common",
		"pages-recaudos-recaudos-module"
	],
	"./pages/ruteros/ruteros.module": [
		"./src/app/pages/ruteros/ruteros.module.ts",
		"ruteros-ruteros-module"
	],
	"./pages/seed-point/seed-point.module": [
		"./src/app/pages/seed-point/seed-point.module.ts",
		"default~pages-seed-point-seed-point-module~pages-seed-update-seed-update-module~puntos-qr-puntos-qr-module",
		"pages-seed-point-seed-point-module"
	],
	"./pages/seed-update/seed-update.module": [
		"./src/app/pages/seed-update/seed-update.module.ts",
		"default~pages-seed-point-seed-point-module~pages-seed-update-seed-update-module~puntos-qr-puntos-qr-module",
		"common",
		"pages-seed-update-seed-update-module"
	],
	"./pages/seeds/seeds.module": [
		"./src/app/pages/seeds/seeds.module.ts",
		"common",
		"seeds-seeds-module"
	],
	"./pages/splash/splash.module": [
		"./src/app/pages/splash/splash.module.ts",
		"pages-splash-splash-module"
	],
	"./pages/tabs/tabs.module": [
		"./src/app/pages/tabs/tabs.module.ts",
		"pages-tabs-tabs-module"
	],
	"./pages/usuarios/usuarios.module": [
		"./src/app/pages/usuarios/usuarios.module.ts",
		"usuarios-usuarios-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;